import * as THREE from 'three';
import { STORM } from '@orb/sim';
import type { Board } from '../game/Board';

/**
 * The storm eye's charges (HUD): a small cyan count over the player's highest storm eye — the kills the
 * eyes have gathered this match (one tally for all of them), each a lasting +1 % to their blow. Projected like the bosses' bars (the steady
 * framing); written only when the position or the count changed.
 */
const _p = new THREE.Vector3();

interface Badge { el: HTMLDivElement; key: string }

export class StormBadges {
  private readonly layer: HTMLDivElement;
  private readonly badges = new Map<object, Badge>();
  private width = innerWidth; private height = innerHeight;

  constructor(host: HTMLElement, private readonly board: Board, private readonly charges: () => number) {
    this.layer = document.createElement('div');
    this.layer.className = 'storm-badges';
    this.layer.setAttribute('aria-hidden', 'true');
    host.append(this.layer);
    const size = () => { this.width = host.clientWidth || innerWidth; this.height = host.clientHeight || innerHeight; };
    size(); new ResizeObserver(size).observe(host);
  }

  update(camera: THREE.Camera) {
    const n = this.charges(), seen = new Set<object>();
    let top: ReturnType<Board['relics']>[number] | null = null;
    for (const r of this.board.relics()) if (r.kind === 's' && r.state !== 'drag' && (!top || r.level > top.level)) top = r;
    for (const r of top ? [top] : []) {
      seen.add(r);
      let b = this.badges.get(r);
      if (!b) {
        const el = document.createElement('div');
        el.className = 'storm-badge';
        b = { el, key: '' };
        this.badges.set(r, b); this.layer.append(el);
      }
      r.gemPosition(_p); _p.y += 0.42;
      _p.project(camera);
      const x = Math.round((_p.x + 1) * this.width / 2), y = Math.round((1 - _p.y) * this.height / 2), key = `${x},${y},${n}`;
      if (key === b.key) continue;
      b.key = key;
      b.el.textContent = `⚡${n}`;
      b.el.title = `+${Math.round(n * STORM.perKill * 100)} % шкоди`;
      b.el.style.transform = `translate(${x}px, ${y}px) translate(-50%, -100%)`;
    }
    for (const [r, b] of this.badges) if (!seen.has(r)) { b.el.remove(); this.badges.delete(r); }
  }
}
